import type { CcmConfigResponse, CcmPlaceholderEntry, CcmSectionPlaceholdersResponse } from '@arhs-fleetback/types/entities/ccm';

import type { MayBe } from 'modules/global/typing/common/common';

export const CCMEntityTypes = {
  groups: 'groups',
  dealers: 'dealers',
} as const;

export type CCMEntityTypesEnum = (typeof CCMEntityTypes)[keyof typeof CCMEntityTypes];

export type CcmEmailMaxLengths = CcmConfigResponse['maxLengths']['email'];

export type EmailPlaceholders = {
  subject?: CcmPlaceholderEntry[];
  title?: CcmPlaceholderEntry[];
  body?: CcmPlaceholderEntry[];
};

export type EmailBaseValues = {
  subject: MayBe<string>;
  title: MayBe<string>;
  body: MayBe<string>;
};

export type EmailField = keyof NonNullable<CcmSectionPlaceholdersResponse['email']>;

export type EmailFieldConfig = {
  label: React.ReactNode;
  labelTooltip?: React.ReactNode;
};
